import React, { useState, useEffect } from 'react';
import * as Icons from '../../components/Icons/SvgIcons';
import styled from '@emotion/styled';
import axios from 'axios';
import { EmotionBreakpoint, BrandUtil } from 'dw-us-ui';
import SlickCaseContents from '../../components/Slick/SlickCaseContents';
import {
  BottleZoom,
  DescriptionTab,
  FoodPairings,
  useContentful,
  FlavorProfiles,
  useProductContentful,
  ProductHeadline,
} from 'dw-us-ui/src/bundles/product-bundle';
import { LoadingIcon } from 'dw-us-ui';
import { clickEventDL } from 'dw-global/apps/dataLayer';

const TastingNotesContainer = styled.div`
  max-width: 970px;
  margin-left: auto;
  margin-right: auto;
  .description-tab {
    text-align: left;
    p {
      line-height: 24px;
      margin: 10px 0px;
    }
  }
  .flavor-profile {
    p {
      font-size: 1em;
      margin: 10px 0px;
    }
  }
  .text-left {
    text-align: left;
  }
  .hide-page {
    display: none;
    min-height: 0px;
  }
  ${EmotionBreakpoint('notMobile')} {
    margin-top: 30px;
    .img-block {
      margin-top: -15px;
    }
  }
  min-height: 380px;
  width: 100%;
  background: #f8f5ef;
  .wsj & {
    background: #f1f1f1;
  }
  .osw & {
    background: #f1f1f1;
  }
  margin-bottom: 30px;
  overflow: auto;
  .title {
    text-align: center;
    width: 100%;
    h1,
    .h1 {
      padding: 12px 24px;
      line-height: 30px;
      background-color: ${({ theme }) => theme.button.primary.backgroundColor};
      color: #fff;
      display: inline-block;
      margin-bottom: 20px;
      text-transform: uppercase;
      font-size: 24px;
      font-family: 'Oswald Regular', georgia, sans-serif;
      .wsj & {
        text-transform: none;
        font-weight: bold;
      }
      .osw & {
        text-transform: none;
        font-weight: bold;
      }
      .npr & {
        background: #d62021;
      }
    }
  }
  .img-padding {
    padding: 6px;
  }
  .hr-line {
    border-top: 1px solid #cacaca;
    margin: 10px 40px;
    ${EmotionBreakpoint('mobile')} {
      margin: 10px 0 0 0;
    }
  }
  ${EmotionBreakpoint('mobile')} {
    h2 {
      margin-top: 15px;
    }
  }
  .share-icons {
    position: relative;
    top: -55px;
    ${EmotionBreakpoint('mobile')} {
      text-align: center;
      top: -7px;
    }
    .print-icon {
      vertical-align: middle;
    }
  }
  .source-image {
    // mix-blend-mode: multiply;
  }
  .preview-attributes-row {
    padding: 15px 0;
    svg {
      vertical-align: text-bottom;
    }
    span {
      padding-left: 5px;
      vertical-align: top;
    }
    ${EmotionBreakpoint('mobile')} {
      padding: 5px 0;
    }
  }
  .wine-description {
    padding: 0 40px 20px !important;
    ${EmotionBreakpoint('mobile')} {
      padding: 0 !important;
    }
  }
  .tab-component {
    margin-right: 20px;
    ${EmotionBreakpoint('mobile')} {
      margin: 0;
    }
  }
  .icons {
    cursor: pointer;
  }
  ul.share-links {
    display: inline-block;
    li {
      display: inline-block;
      margin: 0 5px;
      cursor: pointer;
    }
    span {
      font-size: 18px;
    }
  }
  .embed-responsive-item {
    margin-bottom: 20px;
    height: 250px;
    text-align: center;
  }
  .tasting-notes-image-section {
    ${EmotionBreakpoint('notMobile')} {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .image-section {
      ${EmotionBreakpoint('mobile')} {
        width: 50%;
        display: inline-block;
      }
    }
    .image-section.text-right {
      ${EmotionBreakpoint('notMobile')} {
        margin-right: 15px;
      }
    }
  }
  .quote-section {
    background: #203c5d;
    padding: 15px;
    color: #fff;
    width: 280px;
    height: 280px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 20px;
    .wsj &,
    .osw &,
    .npr & {
      margin-left: 15px;
      width: 275px;
      height: 275px;
    }
    ${EmotionBreakpoint('tablet')} {
      margin-left: 15px;
      width: 215px !important;
      height: 215px !important;
      h2 {
        font-size: 1.3em;
      }
      .law & {
        width: 205px !important;
        height: 205px !important;

        h2 {
          font-size: 1.2em;
        }
      }
    }
    ${EmotionBreakpoint('mobile')} {
      height: 175px !important;
      width: 100% !important;
      margin-left: 0 !important;

      h2 {
        margin-top: 0;
      }
    }
  }
  .bottle-quote-source {
    margin-top: 15px;
  }
  .js-default-tasting-note-image-handler {
    width: 280px;
    height: 280px;
    .wsj &,
    .osw &,
    .npr & {
      width: 275px;
      height: 275px;
    }
    ${EmotionBreakpoint('tablet')} {
      width: 215px !important;
      height: 215px !important;
      .law & {
        width: 205px !important;
        height: 205px !important;
      }
    }
    ${EmotionBreakpoint('mobile')} {
      margin-top: 10px;
      width: 160px !important;
      height: 150px !important;
    }
  }
`;

const BeyondTheLabel = ({ fields, brand }) => {
  const { itemCode } = fields;
  let bottleCategory = 'single';
  let INIIAL_STATE = {
    apiResponse: false,
    apiError: false,
    productDetails: null,
    activeSection: false,
    foodPairings: [],
    lawFlag: false,
    isPrepackItemCode: '',
    itemCode: itemCode,
  };
  if (itemCode.startsWith('M')) {
    bottleCategory = 'mixed';
    INIIAL_STATE = {
      apiResponse: false,
      apiError: false,
      productDetails: false,
      caseContents: [],
      caseSummary: false,
      showSummary: false,
      activeSection: false,
      currentProductIndex: false,
      foodPairings: [],
      productConfig: {},
      lawFlag: false,
    };
  }
  let isPrepackItemCode = itemCode?.substr(-2) == 50 && !itemCode.match('/^[a-z]+$/i');
  const gaCategory = 'Single_Bottle_Product_Page';

  const [state, setState] = useState(INIIAL_STATE);
  const [isProductAvailable, setProductAvailable] = useState(true);
  const [productConfigState, setProductConfigState] = useState({});
  const [isLoading, setLoading] = useState(true);
  // const [mixedCaseState, setMixedCaseState] = useState({
  //   apiResponse: false,
  //   apiError: false,
  //   productDetails: false,
  //   caseContents: [],
  //   caseSummary: false,
  //   showSummary: false,
  //   activeSection: false,
  //   currentProductIndex: false,
  //   foodPairings: [],
  //   productConfig: {},
  //   lawFlag: false,
  // });

  let { tag: brandTag, url: brandUrl, logo } = BrandUtil.content(BrandUtil.getBrand());

  const contentfulOptions = {
    spaceId: 'k1ni6e3k3b2n',
    productionToken: '0090c721437fa809001de135b0bc66ac81c9598f2092b9d513f693dd70d5f781',
    entryId: '3qKlCz35HWAWk2SsWIEG6w',
    includeValue: 1,
    queryObject: {
      contentType: 'foodPairing2',
    },
  };
  useEffect(() => {
    axios
      .get(`/api/product/item/${itemCode}`)
      .then(res => {
        let productDetails = res?.data?.response;
        let accoladeDetails = productDetails?.accolades.length ? productDetails.accolades : false;
        setState(prevState => {
          return {
            ...prevState,
            productDetails,
            accoladeDetails,
          };
        });
        setLoading(false);
      })
      .catch(err => {
        setProductAvailable(false);
        setLoading(false);
      });
  }, []);

  const { response, error } = useContentful(contentfulOptions);

  useEffect(() => {
    if (response) {
      setState(prevState => {
        return {
          ...prevState,
          foodPairings: response.fields.foodPairingsConfig.foodPairingDetails,
        };
      });
    }
    if (error) {
      setState(prevState => {
        return {
          ...prevState,
          foodPairings: [],
        };
      });
    }
  }, [response, error]);

  const socialPopup = platform => {
    switch (platform) {
      case 'facebook':
        window.open(
          `http://www.facebook.com/sharer.php?u=${location.origin}/product/` + state.productDetails.itemCode,
          'popup',
          'width=800,height=600',
        );
        break;
      case 'twitter':
        window.open(
          `https://twitter.com/intent/tweet?url=${location.origin}/product/` + state.productDetails.itemCode,
          'popup',
          'width=800,height=600',
        );
        break;
    }
  };
  const { productConfig } = useProductContentful(itemCode);
  useEffect(() => {
    if (productConfig) {
      setProductConfigState(productConfig);
    }
  }, [productConfig]);

  const getFlavorProfiles = () => {
    if (!productConfigState.flavorProfile) {
      return false;
    } else {
      return (
        <>
          <FlavorProfiles
            itemCode={state?.productDetails?.itemCode}
            activeSection={'Flavor Profiles'}
            flavorProfile={productConfig.flavorProfile}
            title={'Wine Flavor Profile'}
          />
        </>
      );
    }
  };

  const handleProductTransition = (activeSection, product) => {
    useState(prevState => {
      return {
        ...prevState,
        currentProductIndex: activeSection,
      };
    });
    const action = 'caseCarousel';
    // clickEventDL(action, {
    //   clickLocation: "wine case wines",
    //   clickName: "wine case carousel click",
    //   clickAction: "switch wine",
    //   clickText: `${product ? product.name : ""}`,
    //   clickDescription: `pdp:case carousel click`,
    // });
  };
  console.log(bottleCategory, 'bottleCategory');
  return (
    <>
      {!isLoading ? (
        <>
          {isProductAvailable && (
            <div className="no-pad print-container">
              {bottleCategory === 'mixed' && (
                <SlickCaseContents onProductTransition={handleProductTransition} caseContents={state?.caseContents} />
              )}

              <TastingNotesContainer>
                <div id="print-beyond-the-label">
                  <div className="title">
                    <div className="text-center print-image-css">
                      <img src={`${logo}`} className="hide-page" width={'198px'} alt="logo" />
                    </div>
                    <h2 className="h1">Beyond the Label</h2>
                  </div>
                  <div className="col-xs-12 text-right share-icons">
                    <span>
                      <strong>Print / Share</strong>
                    </span>
                    <ul className="share-links">
                      <li>
                        <span
                          className="print-icon default-view"
                          role="presentation"
                          onClick={() => {
                            const action = 'print';
                            clickEventDL(action, {
                              clickLocation: 'vine yard beyond the label',
                              clickName: 'print wine label',
                              clickAction: 'beyond label overlay',
                              clickText: 'print',
                              clickDescription: `pdp:print:${state?.productDetails?.itemCode}`,
                            });
                            window.print();
                          }}
                        >
                          <Icons.PrintIcon />
                        </span>
                      </li>
                      <li>
                        <span onClick={() => socialPopup('facebook')} role="presentation">
                          <img
                            alt="twitter"
                            src={`/images/us/common/icons/${brand.toLowerCase()}/facebook-square-brands.svg`}
                            height="16px"
                            width="15px"
                          />
                        </span>
                      </li>
                      <li>
                        <span onClick={() => socialPopup('twitter')} role="presentation">
                          <img
                            alt="twitter"
                            src={`/images/us/common/icons/${brand.toLowerCase()}/twitter-square-brands.svg`}
                            height="16px"
                            width="15px"
                          />
                        </span>
                      </li>
                      <li>
                        <a
                          href={`mailto: ?subject=I thought you may be interested in this &body=${state?.productDetails?.name} %0D%0A ${location.host}/product/${state?.productDetails?.itemCode}`}
                        >
                          <span className="fa fa-envelope-o icons"></span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="hide-page">
                    {state?.productDetails && (
                      <ProductHeadline productDetails={state?.productDetails} qvEnabled={false} />
                    )}
                  </div>
                  <div className="col-xs-12">&nbsp;</div>
                  <div className="print-about-wine-vineyard">
                    <div className="col-sm-4 col-xs-12 text-center img-block">
                      <BottleZoom
                        image={'/images/us/en/product/' + state?.productDetails?.itemCode + '.png'}
                        imgWidth="39"
                        imgHeight="350"
                        itemCode={state?.productDetails?.itemCode}
                      />
                    </div>
                    <div className="col-sm-8 col-xs-12 text-left">
                      <h2>
                        <strong>About This Wine</strong>
                      </h2>
                      <div className="">
                        <div className="col-md-12 col-xs-12 col-sm-12 no-pad first-section row1">
                          <div className="preview-attributes-row col-md-6">
                            <Icons.WineStyle />
                            <span>{state?.productDetails?.styleName}</span>
                          </div>
                          <div className="preview-attributes-row col-md-6">
                            <Icons.Country />
                            <span>{state?.productDetails?.countryName}</span>
                          </div>
                          <div className="preview-attributes-row col-md-6">
                            <Icons.Grape />
                            <span>{state?.productDetails?.grapeName}</span>
                          </div>
                          <div className="preview-attributes-row col-md-6">
                            <Icons.Alcohol />
                            <span>{state?.productDetails?.alcoholPercent} %</span>
                          </div>
                          {state?.productDetails?.drinkCharacteristics.organic && (
                            <div className="preview-attributes-row col-md-6">
                              <Icons.Organic />
                              <span>Organic</span>
                            </div>
                          )}
                          <div className="preview-attributes-row col-md-6">
                            <Icons.Bottle />
                            <span>{state?.productDetails?.bottleSize} ml</span>
                          </div>
                          <div className="preview-attributes-row col-md-6">
                            <Icons.Calendar />
                            <span>{state?.productDetails?.vintage}</span>
                          </div>
                        </div>
                        <div className="col-md-12 col-xs-12 col-sm-12 no-pad first-section row1">
                          <div className="preview-attributes-row col-md-12 no-pad">
                            {!isPrepackItemCode && state?.productDetails && state.foodPairings.length > 0 && (
                              <>
                                <h2>
                                  <strong>Wine Food Pairings</strong>
                                </h2>
                                <FoodPairings
                                  foodPairings={state.foodPairings}
                                  itemCode={state?.productDetails?.itemCode}
                                  productDetails={state?.productDetails}
                                  activeSection={'Food Pairings'}
                                  isMixed={false}
                                />
                              </>
                            )}
                          </div>
                          <div className="col-xs-12">&nbsp;</div>
                          <div
                            className={`preview-attributes-row col-md-12 no-pad flavor-profile ${
                              !getFlavorProfiles() && 'hidden'
                            }`}
                          >
                            {getFlavorProfiles()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 description-tab">
                    <div className="tab-component hr-line" />
                    {state?.productDetails && (
                      <DescriptionTab
                        productDetails={state?.productDetails}
                        tabName="About This Wine"
                        gaCategory={gaCategory}
                        gaAction={'Product_Details'}
                        descriptionType={'long'}
                      />
                    )}
                  </div>
                  {state.productDetails?.tastingNotes?.mapImageFile ? (
                    <div className="col-xs-12 tasting-notes-image-section">
                      <div className="print-first-child">
                        <div className="no-pad text-center">
                          <div className="quote-section">
                            <h2 className="bottle-quote">{`${
                              state?.accoladeDetails[state?.accoladeDetails?.length - 1]?.accoladeDescription
                            }`}</h2>
                            <span className="bottle-quote-source">
                              {state?.accoladeDetails[state?.accoladeDetails?.length - 1]?.accoladePerson}
                              <br />
                              {state?.accoladeDetails[state?.accoladeDetails?.length - 1]?.accoladeNameText}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="image-section img-padding">
                          <img
                            src={`${brandUrl}/images/uk/en/law/tastingnote/map/${state.productDetails?.tastingNotes?.mapImageFile}.jpg`}
                            className="img-responsive js-default-tasting-note-image-handler"
                            alt="Map showing California"
                            onError={e => {
                              e.target.src = `${brandUrl}/images/uk/en/law/tastingnote/map/${state.productDetails?.tastingNotes?.mapImageFile}.webp`;
                            }}
                          />
                        </div>
                      </div>
                      <div>
                        <div className="image-section text-right">
                          <img
                            src={`${brandUrl}/images/uk/en/law/tastingnote/information/${state.productDetails?.tastingNotes?.otherImageFile}.jpg`}
                            className="img-responsive js-default-tasting-note-image-handler"
                            alt="Tasting note information"
                            onError={e => {
                              e.target.src = `${brandUrl}/images/uk/en/law/tastingnote/information/${state.productDetails?.tastingNotes?.otherImageFile}.webp`;
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <div className="col-xs-12">&nbsp;</div>
                </div>
              </TastingNotesContainer>
            </div>
          )}
        </>
      ) : (
        <LoadingIcon />
      )}
    </>
  );
};

export { BeyondTheLabel };
